import { render, staticRenderFns } from "./Selectproject.vue?vue&type=template&id=50ea52c3&scoped=true&"
import script from "./Selectproject.vue?vue&type=script&lang=js&"
export * from "./Selectproject.vue?vue&type=script&lang=js&"
import style0 from "./Selectproject.vue?vue&type=style&index=0&id=50ea52c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ea52c3",
  null
  
)

export default component.exports